export default __webpack_public_path__ + "294c1fb2b9d924bd420f0aa6f7445ba7.svg";